/**
 * ABM create vs edit identity.
 *
 * Empty Código → POST (alta; backend assigns next code).
 * Filled Código → PATCH that code.
 *
 * Recargar / list reload must never copy código by display name. Typing
 * "Administrador" or "admin" on Nuevo must not become ROL001 / USR001.
 * Edit an existing row only from the listing (click the row).
 */

export function abmCodigoMeansAlta(codigo: string | null | undefined): boolean {
  return !(codigo || "").trim();
}

/**
 * Fill empty código only from listing identity (id), never by name/username.
 * Returns the matching row when Recargar may copy its código; otherwise undefined
 * so the caller keeps the previous form (alta stays alta).
 */
export function adoptCodigoFromListingId<
  T extends { id?: number | null; codigo?: string | null },
>(
  prevCodigo: string | null | undefined,
  rows: T[],
  listingId: number | null | undefined,
): T | undefined {
  if (!abmCodigoMeansAlta(prevCodigo)) return undefined;
  if (listingId == null) return undefined;
  const match = rows.find((row) => row.id === listingId);
  if (!match || abmCodigoMeansAlta(match.codigo)) return undefined;
  return match;
}
